export default __webpack_public_path__ + "static/media/copy.3093ed9d.svg";